/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import CheckCircleFilled from '@ant-design/icons/lib/icons/CheckCircleFilled';
import CloseCircleFilled from '@ant-design/icons/lib/icons/CloseCircleFilled';
import AnswerLeft from '@/assets/2025/topicQuiz/answer_left.png';
import { Radio } from 'antd';

import './index.less';

interface IQuizOption {
  indicator?: string;
  title: any;
  explanation: any;
  isCorrect: boolean;
}

interface IQuizReviewProps {
  // description: string;
  question: any;
  options: IQuizOption[];
  quizIndex: number;
  answer: IQuizOption;
  language: string;
  topic2: any;
}
const RESULTS = {
  CORRECT: 'correct',
  WRONG: 'wrong',
};
const INDICATORS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const QuizReview: React.FunctionComponent<IQuizReviewProps> = (props) => {
  const { question, options, quizIndex, answer, language, topic2 } = props;
  options.forEach((item, index) => {
    item.indicator = INDICATORS[index];
  });

  const getAnswerStyle = (option: IQuizOption) =>
    option.isCorrect
      ? RESULTS.CORRECT
      : option.indicator === answer.indicator
      ? RESULTS.WRONG
      : '';
  return (
    <div className="review-quiz-section">
      <div className="review-quiz-section-body">
        {/*<div className="quiz-title">{settings?.titleLabel}</div>*/}
        <div
          className="quiz-question"
          dangerouslySetInnerHTML={{
            __html: `${quizIndex}. ${question[language]} `,
          }}
        />
        <div className="quiz-answers">
          <Radio.Group value={answer.indicator}>
            {options.map((option: IQuizOption, index) => (
              <div
                key={index}
                className={`quiz-answers-item ${getAnswerStyle(option)}`}
              >
                <Radio value={option.indicator}>
                  {getAnswerStyle(option) === RESULTS.CORRECT && (
                    <CheckCircleFilled />
                  )}
                  {getAnswerStyle(option) === RESULTS.WRONG && (
                    <CloseCircleFilled />
                  )}
                  {getAnswerStyle(option) === '' && (
                    <span className="indicator">{option.indicator}</span>
                  )}
                  {option.title[language]}
                </Radio>
              </div>
            ))}
          </Radio.Group>
        </div>
        <div className="quiz-result-area">
          <img src={AnswerLeft} alt="" />
          <div className="area-right">
            <div className="text">{topic2?.analysisLabel}</div>
            <p
              dangerouslySetInnerHTML={{
                __html:
                  options.find((itm) => itm.isCorrect)?.explanation[language] ||
                  '',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizReview;
